import { CompraAnimalesItem, VentaAnimalesItem } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { ClienteFincaLoteItem } from "../../../../generated/grpc/terceros_lote_pb";
import { grpcLoteDatabase } from "../../../terceros/database/GrpcLoteDatabase";
import { grpcCompraAnimalesDatabase } from "../database/GrpcCompraAnimalesDatabase";
import { grpcVentaAnimalesDatabase } from "../database/GrpcVentaAnimalesDatabase";

/** Lo que el server devuelve ya recalculado al guardar o eliminar un
 *  movimiento de animales (compra, venta o evento de pesaje / rotación /
 *  veterinaria), además del registro propio. Las respuestas de los 6 rpc de
 *  `pesaje_ganaderia.proto` tienen esta forma, así que se pasan tal cual. */
export type CambiosMovimiento = {
  /** Lotes recalculados: animales, ingreso, salida y pesos. */
  readonly lotes: readonly ClienteFincaLoteItem[];
  /** Compras de esos lotes, con sus animales disponibles recalculados. Al
   *  eliminar una compra, todas las de la finca (se renumeran los códigos). */
  readonly compras: readonly CompraAnimalesItem[];
  /** Solo al eliminar una venta: todas las de la finca, con los códigos
   *  renumerados. */
  readonly ventas?: readonly VentaAnimalesItem[];
};

/** Escribe en las bases locales lo que el server recalculó por un movimiento
 *  de animales (2026-10-08). Así el mapa, el dashboard, las listas y los
 *  formularios ven los datos nuevos al cerrar el formulario, sin volver a
 *  pedir los listados.
 *
 *  Reemplaza a `fx_invalidarListasMovimientoAsync`, que solo marcaba los
 *  potreros para bajarlos completos la próxima vez y las compras para pedir
 *  el delta. Ese "pedirlo después" fallaba si algo volvía a activar la espera
 *  de 24 horas antes de volver al mapa, y el mapa quedaba con los datos de
 *  antes del movimiento hasta recargar la página.
 *
 *  El registro guardado o eliminado lo maneja cada servicio en su propia base
 *  (`putOneAsync`/`deleteOneAsync`); esto cubre los demás registros que tocó
 *  el server. */
export async function fx_aplicarCambiosMovimientoAsync(
  cambios: CambiosMovimiento,
): Promise<void> {
  await grpcLoteDatabase.putManyAsync(cambios.lotes);
  await grpcCompraAnimalesDatabase.putManyAsync(cambios.compras);
  if (cambios.ventas) {
    await grpcVentaAnimalesDatabase.putManyAsync(cambios.ventas);
  }
}
